/*
 * @Date: 2024-09-29 10:39:08
 * @LastEditTime: 2024-09-30 16:10:57
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import clickOutside from 'v-click-out';
// import "element-ui/lib/theme-chalk/index.css";
import '../theme/index.css';
import element from './element/index';
import i18n from './i18n';
import App from './App';
import router from './router';
import './permission';
import store from '@/store';
import jsCookie from 'js-cookie';
import Vuex from 'vuex';
import '@/styles/global.scss';
import VueClipBoard from 'vue-clipboard2';
import moment from 'moment';
import { getCodeMessage } from './i18n/codeMessageIndex';
// 导出文件按钮组件
import exportFileBtn from '@/components/exportFileBtn/exportFileBtn.vue';
import './directives'; // 全局挂载自定义指令
import "./util/popupConfig"
// import infiniteScroll from 'vue-infinite-scroll'
// 引入字体图标
import '@/assets/appIconfont/iconfont.css';
import '@/assets/menuIconFont/iconfont.css'; // 全局引入iconfont
// 引入配置
import './peruser.js';
import { getCrmCurrencySymbol, getCrmCurrencyAmountSuffix, getCrmCurrencyId } from '@/util/crmCurrency';

Vue.prototype.$crmCurrencySymbol = () => getCrmCurrencySymbol();
Vue.prototype.$crmCurrencySuffix = () => getCrmCurrencyAmountSuffix();
Vue.prototype.$crmCurrencyId = () => getCrmCurrencyId();

Vue.use(clickOutside);
Vue.use(element);
Vue.use(router);
Vue.use(Vuex);
Vue.use(VueClipBoard);

Vue.config.productionTip = false;
Vue.prototype.$cookie = jsCookie;
Vue.prototype.$moment = moment;
Vue.prototype.$getCodeMessage = function(code, fallbackMessage = '') {
	const locale = (this.$i18n && this.$i18n.locale) || 'zh-CN';
	const template = getCodeMessage(code, locale, fallbackMessage);
	const messageArgs = arguments.length >= 3 ? arguments[2] : undefined;
	if (!Array.isArray(messageArgs) || typeof template !== 'string') return template;
	return template.replace(/\{(\d+)\}/g, (match, idxStr) => {
		const idx = Number(idxStr);
		if (Number.isNaN(idx)) return match;
		const val = messageArgs[idx];
		return val === undefined || val === null ? match : String(val);
	});
};

Vue.component('exportFileBtn', exportFileBtn);

// bus总线 vue实例
Vue.prototype.$bus = new Vue()

const APP_ENV = import.meta.env.VITE_APP_ENV; //当前环境
console.log(APP_ENV, 'APP_ENV 当前环境');

const PROD_ENV = ['pre', 'prod'];
// import Vconsole from 'vconsole';

if (PROD_ENV.indexOf(import.meta.env.VITE_APP_ENV) === -1) {
	// let vConsole = new Vconsole()
	// Vue.use(vConsole)
}

new Vue({
	router,
	store,
	i18n,
	render: h => h(App)
}).$mount('#app');
